<template>
	<Popup
		v-model="selfDisplay"
		title="SIM卡记录"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<!-- 表格 -->
			<div class="base_table">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="iccid"
						label="ICCID"
					>
					</el-table-column>
					<el-table-column
						prop="mid"
						label="机器ID"
					>
					</el-table-column>
					<el-table-column
						prop="validLabel"
						label="是否有效"
					>
					</el-table-column>
					<el-table-column
						prop="createDate"
						label="生产日期"
					>
					</el-table-column>
					<el-table-column
						prop="firstUseDate"
						label="首次使用日期"
					>
					</el-table-column>
					<el-table-column
						prop="meal"
						label="套餐信息"
					>
					</el-table-column>
					<el-table-column
						prop="overDate"
						label="到期日期"
					>
					</el-table-column>
					<el-table-column
						prop="cost"
						label="费用/元"
					>
					</el-table-column>
					<el-table-column
						prop="useTime"
						label="使用时间"
					>
					</el-table-column>
					<el-table-column
						prop="remark"
						label="备注"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="page"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end-->
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: Number,
				default: -1
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				page: 1,
				total: 0,
				tableData: []
			}
		},
		methods: {
			// 切换页码
			handlePageChange(page) {
				if (this.page != page) {
					this.page = page;
					this.getData();
				}
			},
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.page,
					pageSize: 10,
					detectorId: that.id
				};
				Api.getSIMRecordByIF(requestData).then((res) => {
					if (res.data.success) {
						let list = [];
						that.loading = false;
						res.data.data.records.forEach(v => {
							list.push({
								iccid: v.simCard.iccid,
								mid: v.simCard.machineId,
								validLabel: v.simCard.simFlag == 1 ? '有效' : '无效',
								createDate: v.simCard.productionDate,
								firstUseDate: v.simCard.firstUseTime.split(' ')[0],
								meal: v.simCard.packagesInfo,
								overDate: v.simCard.dieDate.split(' ')[0],
								cost: v.simCard.feeInfo,
								useTime: v.createTs,
								remark: v.simCard.remark
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.getData();
				} else {
					this.loading = false;
					this.page = 1;
					this.total = 0;
					this.tableData = [];
				}
			}
		}
	}
</script>

<style>
</style>
